"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable no-unused-vars */
/* eslint-disable indent */
const vue_property_decorator_1 = require("vue-property-decorator");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const AveragePanel_vue_1 = __importDefault(require("./AveragePanel.vue"));
const Graphic_vue_1 = __importDefault(require("./Graphic.vue"));
let DistroToolMain = class DistroToolMain extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.distributionOptions = ['Crop', 'Country'];
        this.currentDistribution = this.distributionOptions[0];
    }
    get distribution() {
        const distributions = [];
        for (const distribution of this.distroData.distributions) {
            distributions.push(distribution);
        }
        if (this.distributionCurrent.toLowerCase() === 'crop') {
            return distributions[0];
        }
        else {
            return distributions[1];
        }
    }
    distributionSelect(distribution) {
        this.currentDistribution = distribution;
        this.$emit('currentDistribution', this.currentDistribution);
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: '' })
], DistroToolMain.prototype, "title", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: 'crop' })
], DistroToolMain.prototype, "distributionCurrent", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: {} })
], DistroToolMain.prototype, "distroData", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: {} })
], DistroToolMain.prototype, "currentAverage", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: false })
], DistroToolMain.prototype, "isLoading", void 0);
DistroToolMain = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: { Select: bmk_ui_framework_1.Select, AveragePanel: AveragePanel_vue_1.default, Graphic: Graphic_vue_1.default },
    })
], DistroToolMain);
exports.default = DistroToolMain;
